import {
  createRootRoute,
  createRoute,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { createElement } from "react";
import { AdminLayout } from "./routes/_layout";
import { LoginPage } from "./routes/login";
import { AcceptInvitePage } from "./routes/accept-invite";
import { DppsPage } from "./routes/dpps";
import { DppPage } from "./routes/dpp";
import { MintPage } from "./routes/mint";
import { SubmissionsPage } from "./routes/submissions";
import { TransfersPage } from "./routes/transfers";
import { IssuesPage } from "./routes/issues";
import { AnalyticsPage } from "./routes/analytics";
import { UsersPage } from "./routes/users";
import { CustomersPage } from "./routes/customers";
import { CustomerPage } from "./routes/customer";
import { storedRefreshToken } from "./lib/api";

const rootRoute = createRootRoute({
  component: () => createElement(Outlet),
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const acceptInviteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/accept-invite",
  component: AcceptInvitePage,
});

const layoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "layout",
  component: AdminLayout,
  beforeLoad: () => {
    if (!storedRefreshToken()) throw redirect({ to: "/login" });
  },
});

const indexRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/dpps" });
  },
});

const dppsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/dpps",
  component: DppsPage,
});

const dppRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/dpp",
  component: DppPage,
  validateSearch: (s: Record<string, unknown>) => ({
    brand: String(s.brand ?? ""),
    model: String(s.model ?? ""),
    serial: String(s.serial ?? ""),
  }),
});

const mintRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/mint",
  component: MintPage,
});

const submissionsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/submissions",
  component: SubmissionsPage,
});

const transfersRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/transfers",
  component: TransfersPage,
});

const issuesRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/issues",
  component: IssuesPage,
});

const analyticsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/analytics",
  component: AnalyticsPage,
});

const usersRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/users",
  component: UsersPage,
});

const customersRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/customers",
  component: CustomersPage,
});

const customerRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "/customer",
  component: CustomerPage,
  validateSearch: (s: Record<string, unknown>) => ({
    id: String(s.id ?? ""),
  }),
});

export const routeTree = rootRoute.addChildren([
  loginRoute,
  acceptInviteRoute,
  layoutRoute.addChildren([
    indexRoute,
    dppsRoute,
    dppRoute,
    mintRoute,
    submissionsRoute,
    transfersRoute,
    issuesRoute,
    analyticsRoute,
    usersRoute,
    customersRoute,
    customerRoute,
  ]),
]);
